import GenderCategory from "./GenderCategory/GenderCategory";
import ProductStatus from "./ProductStatus/PorductStatus";
import ProductClass from "./ProductClass/ProductClass";
import SaleOrderList from "./SaleOrder/SaleOrderList";
import InseamLabel from "./InseamLabel/InseamLabel";
import PaymentType from "./PaymentType/PaymentType";
import FitCategory from "./FitCategory/FitCategory";
import SalePerson from "./salesPerson/salePerson";
import RiseLabel from "./RiseLabel/RiseLabel";
import SaleOrder from "./SaleOrder/SaleOrder";
import ItemType from "./ItemType/ItemType";
import CustomerNewForm from "./CustomerNew/components/Form/CustomerNewForm";
import WashType from "./WashType/WashType";
import Product from "./Product/Product";
import Gender from "./Gender/Gender";
import Inseam from "./Inseam/Inseam";
import Season from "./Season/Season";
import Fabric from "./Fabric/Fabric";
import Style from "./Style/Style";
import Rise from "./Rise/Rise";
import Wash from "./Wash/Wash";
import Size from "./Size/Size";
import Cut from "./Cut/Cut";
import Region from "./Region/Region";
import State from "./State/State";
import Country from "./Country/Country";
import City from "./City/City";
import RegionSale from "./RegionSale/RegionSale";
import ShipVia from "./Ship/ShipVia";
import ShippingMethod from "./ShippingMethod/ShippingMethod";
import FreightTerm from "./FreightTerm/FreightTerm";
import BerganBilling from "./BerganBilling/BerganBilling";
import CourierService from "./CourierService/CourierService";
import AdminUser from "./User/AdminUser";
import UserRights from "./UserRights/UserRights";
import ProductList from "./Product/ProductList";
import AdminMenu from "./AdminMenu/AdminMenu";
import Paymentterm from "./Paymentterm/Paymentterm";
import TaxSetup from "./AdminTax/TaxSetup";
import ChartOfAccount from "./ChartOfAccount/ChartofAccount";
import InvoiceList from "./InvoiceNew/InvoiceListNew";
import Company from "./UserCompany/Company";
import AccountType from "./AccountType/AccountType";
import ReturnReason from "./ReturnReason/ReturnReason";
import AdminLocation from "./AdminLocation/AdminLocation";
import SalesTarget from "./SalesTarget/SalesTarget";
import OrderStatus from "./orderStatus/OrderStatus";
import PickTicketStatus from "./PickTicketStatus/PickTicketStatus";
import ShipStatus from "./ShipStatus/ShipStatus";
import FiscalYear from "./FiscalYear/FiscalYear";
import ItemReceiptList from "./Receipt/receiptList";
import ProductDetail from "./Product/ProductDetail"
import Vendor from "./Vendor/vendor";
import ItemCreditNoteList from "./Credit/creditList";
import ItemCredit from "./Credit/ItemCredit";
import ItemTransfer from "./ItemTransfer/ItemTransfer";
import ItemTransferList from "./ItemTransfer/ItemTransferList";
import VendorCategory from "./VendorCategory/vendorCategory";
import Bill from "./Bill/Bill";
import BillList from "./Bill/BillList";
import ProductReportList from "./ProducList/ProductReportList";
import OrderReprot from "./OrderReports/OrderReport";
import ReturnType from "./AdminReturnType/ReturnType";
import SaleOrderAdjustmentNew from "./saleOrderAdjustmentNew/saleOrderAdjustmentNew";
import FabricComposition from "./FabricComposition/FabricComposition";
import FabricClass from "./FabricClass.js/FabricClass";
import FabricClass2 from "./FabricClass2/FabricClass2";
import FabricType from "./FabricType/FabricType";
import FabricUsable from "./FabricUsable/FabricUsable";
import ChargeBackType from "./ChargeBackType/ChargeBackType";
import ChargeBackTypeList from "./ChargeBackType/ChargeBackTypeList";
import CommitCriteria from "./CommitCriteria/CommitCriteria";
import CustomerPayment from "./CustomerPayment/CustomerPayment";
import PaymentHeaderList from "./CustomerPayment/PaymentHeaderList";
import InventoryAdjustment from "./InventoryAdjustmentNew/InventoryAdjustmentNew";
import InventoryAdjustmentNewList from "./InventoryAdjustmentNew/InventoryAdjusmentNewList";
import PendingPOD from "./Pending POD/PendingPOD";
import SalesTargetRetport from "./SalesTargetReport/SalesTargetReport";
import AdminModule from "./AdminModule/AdminModule";
import CustomerType from "./CustomerType/CutomerType";
import TermForPrint from "./TermForPrint/TermForPrint";
import BusinessDashboard from "./BusinessDashboard/BusinessDashboard";
import OmsBooking from "./OMSBooking/OmsBooking";
import AdminJob from "./AdminJob/AdminJob";
import AdminDiscount from "./AdminDiscount/AdminDiscount";
import Factor from "./Factor/factor";
import AdminMenuType from "./AdminMenuType/AdminMenuType";
import PaymentMethodType from "./PaymentMethodType/paymentMethodType";
import AdminCurrency from "./AdminCurrency/AdminCurrency";
import BarganPaymentTerm from "./BaraganPaymentTerm/BarganPaymentTerm";
import ScmBrand from "./ScmBrand/ScmBrand";
import SalesReport from "./SalesReport/SalesReport";
import NewSalesReport from "./SalesReport/NewSalesReport.js";
import BillPaymentList from "./BillPayment/BillPaymentList";
import OmsPendingOrder from "./OMSPendingOrder/OmsPendingOrder";
import CustomerRefund from "./CustomerRefund/CustomerRefund";
import customerRefundList from "./CustomerRefund/CustomerRefundList";
import Distributor from "./Distributor/Distributor";
import OmsShipping from "./OMSShipping/OmsShipping";
import OmsPendingPOD from "./OMSPendingPOD/OmsPendingPOD";
import ScmFigure from "./ScmFigure/ScmFigure";
import JournalVoucher from "./JournalVoucher/JournalVoucher";
import JournalVoucherList from "./JournalVoucher/JournalVoucherList";
import BillPayment from "./BillPayment/BillPayment"
import OmsReturn from "./OMSReturn/OmsReturn";
import OmsStockDetails from "./OMSStockDetails/OmsStockDetails";
import BillDirectPayment from "./BillDirectPayment/BillDirectPayment";
import BillDirectPaymentList from "./BillDirectPayment/BillDirectPaymentList";
import Payment from "./Payment/Payment";
import FundTransfer from "./FundTransfer/FundTransfer";
import FundTransferList from "./FundTransfer/FundTransferList";
import Deposit from "./Deposit/Deposit";
import DepositList from "./Deposit/DepositList";
import CustomerPaymentLedger from "./CustomerPaymentLedger/CustomerPaymentLedger"
import POLookup from "./QuickPOLookUP/POLookup";
import OmsStockSummaryInitial from "./OMSStockSummary/omsStocksummaryInitial";
import OmsStockSummary from "./OMSStockSummarySKU/OmsStockSummary";
import OmsStockSummaryStyle from "./OMSStockSummary/OmsStockSummary";
import OrderReport from "./OrderReport/OrderReport";
import ProductType from "./ProductType/ProductType";
import CustomerCategory from "./CustomerCategory/CustomerCategory";
import SalesReturnReport from "./SalesReturnReport/SalesReturnReport";
import SalesInvoiceReport from "./SaleInvoiceReport/SalesInvoiceReport";
import UpcSetup from "./UpcSetup/upcSetup";
import PendingStyleWise from "./PendingStyleWiseReport/PendingStyleWise";
import BookedStyleWise from "./BookedStyleWiseReport/BookedStyleWise";
import ShippedStyleWise from "./ShippedStyleWiseReport/ShippedStyleWise";
import QueryTool from "./QueryTool/QueryTool";
import BookSummary from "../Reports/Booked/BookSummary";
import B_Grade_Stock from "./B Grade Stock/BGradeStock";
import ProductReport from "./ProductReport/ProductReport";
import PendingSummary from "./PendingSummary/PendingSummary";
import ShippedSummary from "./ShippedSummary/ShippedSummary";
import ReturnSummary from "./ReturnSummary/ReturnSummary";
import PODStyleWise from "./PODStyleWise/PODStyleWise";
import BookDetail from "../Reports/Booked/BookDetail";
import PendingDetailReport from "./Pending Order Report/PendingDetailReport";
import ShippedDetailReport from "./ShippedReports/ShippedDetailReport.js";
import orderShipmentNew from "./OrderShipmentNew/OrderShipmentNew";
import orderShipmentListNew from "./OrderShipmentNew/OrderShipmentListNew";
import PickTicketSummary from "./PickTicket Summary/PickTicketSummary";
import RelocateItems from "./RelocateItems/RelocateItems";
import ReturnAuthorization from "./SaleReturnNew/SaleReturn.js";
import ReturnAuthList from "./SaleReturnNew/ReturnAuthList.js";
import SaleOrderAdjustmentNewList from "./saleOrderAdjustmentNew/saleOrderAdjustmentNewList";
import CreditNote from "./CreditNote/CreditNote";
import UpdateTool from "./UpdateTool/UpdateTool";
import PendingPodSummary from "./PendingPodSummary/PendingPodSummary"
import ItemReceiptNew from "./Receipt copy/ItemReceiptNew";
import ItemReceiptListNew from "./Receipt copy/ItemReceiptList";
import PtSummary from "./PickTicketSummary/PtSummary";
import OrderAdjustmentReport from "./OrderAdjustmentReport/OrderAdjustmentReport";
import OrderAdjDetail from "./OrderAdjDetail/OrderAdjDetail";
import InvoiceNew from "./InvoiceNew/InvoiceNew";
import PtDetail from "./PtDetail/PtDetail"
import CreditMemoReport from "./CreditMemoReports/CreditMemoReport"
import CreditOpenInvoicedetailReport from "./CreditOpenInvoicedetailReport/CreditOpenInvoiceDetailReport"
import SalesAdjustmentReport from "./SalesAdjustmentReport/SalesAdjustmentReport"
import CustomerNewList from "./CustomerNew/CustomerNewList";
import CustomerNew from "./CustomerNew/CustomerNew";
import ControlSheet from "./ControlSheet/ControlSheet";
import ReturnStyleWise from "./ReturnStyleWiseReport/ReturnStyleWise";
import CustomerInfo from "./CustomerInfoReport/CustomerInfo"
import ProductInfo from "./ProductInfoReport/ProductInfo"
import ReturnDetailReport from "./ReturnDetailReport/ReturnDetailReport";
import BillCredit from "./BillCredit/BillCredit";
import BillCreditList from "./BillCredit/BillCreditList";
import CreditMemo from "./CreditMemo/CreditMemo";
import CreditMemoList from "./CreditMemo/CreditMemoList";
import customerRefundReport from "./customerRefundReport/customerRefundReport"

import PaymentReceiptReport from "./paymentReceiptReport/paymentReceiptReport"
import IntransitReport from "./Intransit/IntransitReport";
import ProductionReport from "./Production/productionReport";
import Distributor2 from "./NewReport/Distributor2";
import OTSDashboard from "./OTSDashboard/OTSDashboard"
import PendingPodSummaryAr from "./PendingPodSummaryAr/PendingPodSummaryAr";
import CustomerBalances from "./CustomerBalances/CustomerBalances";
import InternationalOrder from "./InternationalOrder/InternationalOrder";
import CanadaOrder from "./CanadaOrder/CanadaOrder";

import PurchaseBill from "./PurchaseBill/purchaseBill";
import CitReport from "./CITReport/citReport";
import CreditPrintReport from "./CreditPrintReport/CreditPrintReport";
import DlShowroom from "./dlShowroom/dlShowroom";
import InventoryReport from "./InventoryReport/InventoryReport";
import DscoInvoiceReport from "./DscoInvoiceReport/DscoInvoiceReport";
import PODDetail from "./PODDetail/PODDetail";
import SeasonYear from "./SeasonYear/SeasonYear";
import UpcSetup1 from "./UpcSetup/uploadProps";
import SalesPersonList from "./salesPerson/salesPersonList";
import InvoiceEmail from "./InvoiceEmail/InvoiceEmail";
import ProductInfoNew from "./ProductInfo/ProductInfoNew";
import UpdateProductInfo from "./UpdateProductInfo/UpdateProductInfo";
import VendorList from "./Vendor/VendorList";
import ImediateOtsBySize from "./OMSStockSummarySKU/OmsStockSummary2";
import LocationWise from "./LocationWise/LocationWise";
import CommissionReport from "./CommissionReport/CommissionReport";
import ProductInfoBySize from "./ProductInfoBySize/ProductInfoBySize";
import GoodRequired from "./GoodRequired/GoodRequired";
import ArAgingSummary from "./ArAgingSummary/ArAgingSummary";
import SkuLookUpNu from "./SKULookUpNu/SkuLookUpNu";
import PendingSkuLookUp from "./PendingSKULookUp/PendingSkuLookUp";
import InterLog from "./InterLog/InterLog";
import CustomerPaymentLedgerAR from "./CustomerPaymentLedgerAR/CustomerPaymentLedgerAR";
import TotalOTSbySize from "./TotalOTSbySize/TotalOTSbySize";
import SelectQuery from "./SelectQuery/SelectQuery";
import InvoicePending from "./InvoicePending/InvoicePending";
import IncomeStatement from "./IncomeStatement/IncomeStatement";
import Routine from "./Routines/Routine";
import RoutineOrder from "./RoutineOrder/RoutineOrder";
import StockUpdate from "./StockUpdate/StockUpdate.js";
import ImediateOtsBySize2 from "./ImediateOtsBySize2/ImediateOtsBySize2";
import ImediateOtsBySize3 from "./ImediateOtsBySize3/ImediateOtsBySize3";
import IncomeDetail from "./incomeDetail/incomeDetail";
import VenderLedger from "./VenderLedger/VenderLedger";
import BalanceSheet from "./BalanceSheet/BalanceSheet";
import UPCReport from "./UPCReport/UPCReport";
import BalanceDetail from "./BalanceDetail/balanceDetail";
import DoNotCommit from "./DoNotCommit/DoNotCommit";
import NewOrderReport from "./OrderReport/NewOrderReport";
import ControlSheetLog from "./ControlSheetLog/controlSheetLog";
import ProductToBergen from "./ProductToBergen/productToBergen";
import PaymentLedgerSummaryReport from "./PaymentLedgerSummaryReport/PaymentLedgerSummaryReport";
import AsnToBergen from "./AsnToBergen/AsnToBergen.js";
import OMSStyleReport from "./OMSStyleReport/OMSStyleReport";
import OMSWashReport from "./OMSWashReport/OMSWashReport";
import ProductImageReport from "./ProductByImage/ProductImageReport";
import BergenEdi from "./BergenEdi/BergenEdi";
import StitchFixEdi from "./StitchFixEdi/StitchFixEdi";
import StyleLedger from "./StyleLedger/StyleLedger.js";
import TotalOts from "./TotalOts/TotalOts";
import PtToBergen from "./PtToBergen/ptToBergen";
import ChartofAccountReport from "./ChartofAccountReport/ChartofAccountReport.js";
import OmsStyleReportNew from "./OmsStyleReportNew/OmsStyleReportNew.jsx";
import OmsWashReportNew from "./OmsWashReportNew/OmsWashReportNew.jsx"
import StyleShot from "./StyleShot/StyleShot.jsx";
import StyleDistro from "./StyleDistro/StyleDistro.jsx";
import VendorSummary from "./VendorSummary/VendorSummary.js";
import Expense from "./Expense/Expense.js";
import RAToBergen from "./RAToBergen/raToBergen";
import ARInventory from "./ARInventory/ARInventory.jsx";
import RAToBergen2 from "./RAToBergen/raToBergen2";
import InventoryValuation from "./InventoryValuation/InventoryValuation.jsx";
import JournalLedger from "./JournalLedger/JournalLedger.jsx";
import GeneralLedger from "./GeneralLedger/GeneralLedger.jsx";
import OmsStockSummaryAts from "./OMSStockSummaryATS/OmsStockSummaryAts.jsx";
import PickTicketDetail from "./PickTicketDetail/PickTicketDetail.js";
import StockStyleWise from "./StockStyleWise/stockStyleWise.js";
import CustomerPaymentLedgerNew from "./CustomerPaymentLedgerNew/customerPaymentLedgerNew.js";
import BalanceSheetNew from "./BalanceSheetNew/BalanceSheetNew.jsx";
import APAgingDetail from "./APAgingDetail/APAgingDetail.jsx";
import IncomeStatementNew from "./IncomeStatementNew/IncomeStatementNew.jsx";
import JournalLedgerNew from "./JournalLedgerNew/JournalLedgerNew.jsx";
import AvalaraInvoice from "./AvalaraInvoice/AvalaraInvoice.jsx";
import SalesTargetRetportDashboard from "./SalesTargetReportDashboard/SalesTargetReportDashboard.jsx";
import CheckPay from "./CheckPay/CheckPay.js";
import CrmSkuWise from "./CrmSkuWise/CrmSkuWise.js";
import CRMReport from "./CRMReport/crmReport.js";
import TransactionLock from "./TransactionLock/TransactionLock.js";
import SalesTargetReportSalePerson from "./SalesTargetReportSalePerson/SalesTargetReportSalePerson.jsx";
import ChargeBackDetail from "./ChargeBackDetail/chargeBackDetail.js";
import ForgetPassword from "./ForgetPassword/ForgetPassword.js";
import UpcToItemCode from "./UpcToItemCode/UpcToItemCode.js";
import NetShippedStyleWise from "./NetShippedStyleWise/netShippedStyleWise.jsx";
import CustomerHold from "./CustomerHold/CustomerHold.js";
import MissingUpc from "./MissingUpc/missingUpc.jsx";
import CustomerPaymentLedgerDateWise from "./CustomerPaymentLedgerDateWise/CustomerPaymentLedgerDateWise.js";
import PendingOrderAvailabilityBySize from "./PendingOrderAvailabilityBySize/PendingOrderAvailabilityBySize.js";
import NegativeOrderOtsWise from "./NegativeOrderOtsWise/NegativeOrderOtsWise.js";
import NegativeOrderOtsWise2 from "./NegativeOrderOtsWise/NegativeOrderOtsWise2.js";
import Brand from "./Brand/Brand.js";
import SkuExistsErp from "./SkuExistsErp/SkuExistsErp.js";
import OnlineOrdersSummary from "./OnlineOrdersSummary/OnlineOrdersSummary.js";
import SpecialityByRegion from "./SpecialityByRegion/SpecialityByRegion.jsx";
import SpecialityByState from "./SpecialityByState/SpecialityByState.jsx";
import SpecialityByCustomer from "./SpecialityByCustomer/SpecialityByCustomer.jsx";
import EcommerceByStyle from "./EcommerceByStyle/EcommerceByStyle.jsx";
import DLBulk from "./DLBulk/DLBulk.jsx";
import WWBulk from "./WWBulk/WWBulk.jsx";
import ProductMigration from "./ProductMigration/ProductMigration.jsx";
import SpecialtyByStyle from "./SpecialtyByStyle/SpecialtyByStyle.js";
import RoutineLog from "./RoutineLog/routineLog.jsx";
import ImageUploaderNu from "./ImageUploaderNu/imageUploaderNu.js";
import ScheelsEdi from "./ScheelsEdi/ScheelsEdi.js";
import Profile from "./Profile/Profile.js";
import LeaderBoard from "./LeaderBoard/LeaderBoard.js";
import CustomerRefundReportNew from "./customerRefundReportNew/customerRefundReportNew.js";
import ControlSheet2 from "./ControlSheet/ControlSheet2.js";
import InvoiceEmailTest from "./InvoiceEmail/InvoiceEmailTest";
import ProductionFinished from "./ProductionFinished/ProductionFinished.js";
import OMSStockStyleWiseSummary from "./OMSStockStyleWiseSummary/OMSStockStyleWiseSummary";
import ProductImageUrl from "./ProductImageUrl/ProductImageUrl.js";
import CustomerbyPO from "./CustomerbyPO/CustomerbyPO.js";
import DropshipSKU from "./DropshipSKU/DropshipSKU.js";
import DropshipTotal from "./DropshipTotal/DropshipTotal.js";
import SpecialityByMonth from "./SpecialityByMonth/SpecialityByMonth.jsx";
import CalenderForm from "./Calendar/Calendar.js";
import EventCalendar from "./EventCalendar/EventCalendar.js";
import AvalaraReturn from "./AvalaraReturn/AvalaraReturn.jsx";
import CCOrderProcessing from "./CCOrderProcessing/CCOrderProcessing.js";
import InvoicePendingPdf from "./InvoicePendingPdf/InvoicePendingPdf.js";
import CreditNoteEmail from "./CreditNoteEmail/CreditNoteEmail.js";
import CreditNoteEmailPdf from "./CreditNoteEmailPdf/CreditNoteEmailPdf.js";
import ProductImageReportNew from "./ProductByImageNew/ProductImageReportNew.jsx";
import BusinessDashboardNew from "./BusinessDashboardNew/BusinessDashboardNew.js";
import AllocationReport from "./allocationReport/allocationReport.js";
import StyleWiseDetail from "../Reports/Booked/StyleWiseDetail.js";
import Collaterals from "./Collaterals/Collaterals.js";
import ItemCodeToUpc from "./ItemCodeToUpc/ItemCodeToUpc.js";
import NetShippedInventory from "./NetShippedInventory/NetShippedInventory.js";
import FabricWiseInventory from "./FabricWiseInventory/FabricWiseInventory";
import StyleWiseInventory from "./StyleWiseInventory/StyleWiseInventory.js";
import SizeCurveReport from "./SizeCurveReport/sizeCurveReport.js";
import SpecialtyByBookingReport from "./SpecialtyByBookingReport/SpecialtyByBookingReport.jsx";
import UserRightsMultiple from "./UserRightsMultiple/UserRightsMultiple.js";
import Dashboard from "./Dashboard/Dashboard.js";
import DLBill from "./DLBill/DLBill.jsx";
import ProductionSKUWisePercentage from "./ShippedStyleWisePercentage/ProductionSKUWisePercentage.js";
import ShippedStyleWisePercentage2 from "./ShippedStyleWisePercentage/ShippedStyleWisePercentage2.js";
import paymentReceiptReportNew from "./paymentReceiptReportNew/paymentReceiptReportNew.js";
import AdminDepartment from "./AdminDepartment/AdminDepartment.js";
import JournalVoucherReport from "./journalVoucherReport/journalVoucherReport.js";
import UserRegion from "./UserRegion/UserRegion.js";
import ArCustomerPaymentLedger from "./ArCustomerPaymentLedger/ArCustomerPaymentLedger.js";
import PaymentAdjustment from "./paymentAdjustment/paymentAdjustment.js";
import ControlSheetAdvanceShip from "./ControlSheetAdvanceship/ControlSheetAdvanceship.js";
import CustomerAdjustmentReport from "./customerAdjustmentReport/customerAdjustmentReport.js";
import CustomerCreditReport from "./customerCreditReport/customerCreditReport.js";
import ReturnAuthorizationReport from "./ReturnAuthorizationReport/ReturnAuthorizationReport.jsx";
import CustomerPaymentPrint from "./CustomerPaymentPrint/CustomerPaymentPrint.js";
import ControlSheetAdvanceShipLog from "./ControlSheetAdvanceshipLog/ControlSheetAdvanceshipLog.js";
import CustomerRefundPrint from "./CustomerRefundPrint/CustomerRefundPrint.js";
import PendingStyleWiseWithAvailability from "./PendingStyleWiseWithAvailability/PendingStyleWiseWithAvailability.js";

export {
    GenderCategory,
    ProductStatus,
    ProductClass,
    SaleOrderList,
    InseamLabel,
    PaymentType,
    FitCategory,
    SalePerson,
    RiseLabel,
    SaleOrder,
    ItemType,
    CustomerNewForm,
    WashType,
    Product,
    Gender,
    Inseam,
    Season,
    Fabric,
    Style,
    Rise,
    Wash,
    Size,
    Cut,
    Region,
    State,
    Country,
    City,
    RegionSale,
    ShipVia,
    ShippingMethod,
    FreightTerm,
    BerganBilling,
    CourierService,
    AdminUser,
    UserRights,
    ProductList,
    AdminMenu,
    Paymentterm,
    TaxSetup,
    ChartOfAccount,
    InvoiceList,
    Company,
    AccountType,
    ReturnReason,
    AdminLocation,
    SalesTarget,
    OrderStatus,
    PickTicketStatus,
    ShipStatus,
    FiscalYear,
    ItemReceiptList,
    ProductDetail,
    Vendor,
    ItemCreditNoteList,
    ItemCredit,
    ItemTransfer,
    ItemTransferList,
    VendorCategory,
    Bill,
    BillList,
    ProductReportList,
    OrderReprot,
    ReturnType,
    SaleOrderAdjustmentNew,
    FabricComposition,
    FabricClass,
    FabricClass2,
    FabricType,
    FabricUsable,
    ChargeBackType,
    ChargeBackTypeList,
    CommitCriteria,
    CustomerPayment,
    PaymentHeaderList,
    InventoryAdjustment,
    InventoryAdjustmentNewList,
    PendingPOD,
    SalesTargetRetport,
    AdminModule,
    CustomerType,
    TermForPrint,
    BusinessDashboard,
    OmsBooking,
    AdminJob,
    AdminDiscount,
    Factor,
    AdminMenuType,
    PaymentMethodType,
    AdminCurrency,
    BarganPaymentTerm,
    ScmBrand,
    SalesReport,
    NewSalesReport,
    BillPaymentList,
    OmsPendingOrder,
    CustomerRefund,
    customerRefundList,
    Distributor,
    OmsShipping,
    OmsPendingPOD,
    ScmFigure,
    JournalVoucher,
    JournalVoucherList,
    BillPayment,
    OmsReturn,
    OmsStockDetails,
    BillDirectPayment,
    BillDirectPaymentList,
    Payment,
    FundTransfer,
    FundTransferList,
    Deposit,
    DepositList,
    CustomerPaymentLedger,
    POLookup,
    OmsStockSummaryInitial,
    OmsStockSummary,
    OmsStockSummaryStyle,
    OrderReport,
    ProductType,
    CustomerCategory,
    SalesReturnReport,
    SalesInvoiceReport,
    UpcSetup,
    PendingStyleWise,
    BookedStyleWise,
    ShippedStyleWise,
    QueryTool,
    BookSummary,
    B_Grade_Stock,
    ProductReport,
    PendingSummary,
    ShippedSummary,
    ReturnSummary,
    PODStyleWise,
    BookDetail,
    PendingDetailReport,
    ShippedDetailReport,
    orderShipmentNew,
    orderShipmentListNew,
    PickTicketSummary,
    RelocateItems,
    ReturnAuthorization,
    ReturnAuthList,
    SaleOrderAdjustmentNewList,
    CreditNote,
    UpdateTool,
    PendingPodSummary,
    ItemReceiptNew,
    ItemReceiptListNew,
    PtSummary,
    OrderAdjustmentReport,
    OrderAdjDetail,
    InvoiceNew,
    PtDetail,
    CreditMemoReport,
    CreditOpenInvoicedetailReport,
    SalesAdjustmentReport,
    CustomerNewList,
    CustomerNew,
    ControlSheet,
    ReturnStyleWise,
    CustomerInfo,
    ProductInfo,
    ReturnDetailReport,
    BillCredit,
    BillCreditList,
    CreditMemo,
    CreditMemoList,
    customerRefundReport,

    PaymentReceiptReport,
    IntransitReport,
    ProductionReport,
    Distributor2,
    OTSDashboard,
    PendingPodSummaryAr,
    CustomerBalances,
    InternationalOrder,
    CanadaOrder,

    PurchaseBill,
    CitReport,
    CreditPrintReport,
    DlShowroom,
    InventoryReport,
    DscoInvoiceReport,
    PODDetail,
    SeasonYear,
    UpcSetup1,
    SalesPersonList,
    InvoiceEmail,
    ProductInfoNew,
    UpdateProductInfo,
    VendorList,
    ImediateOtsBySize,
    LocationWise,
    CommissionReport,
    ProductInfoBySize,
    GoodRequired,
    ArAgingSummary,
    SkuLookUpNu,
    PendingSkuLookUp,
    InterLog,
    CustomerPaymentLedgerAR,
    TotalOTSbySize,
    SelectQuery,
    InvoicePending,
    IncomeStatement,
    Routine,
    RoutineOrder,
    StockUpdate,
    ImediateOtsBySize2,
    ImediateOtsBySize3,
    IncomeDetail,
    VenderLedger,
    BalanceSheet,
    UPCReport,
    BalanceDetail,
    DoNotCommit,
    NewOrderReport,
    ControlSheetLog,
    ProductToBergen,
    PaymentLedgerSummaryReport,
    AsnToBergen,
    OMSStyleReport,
    OMSWashReport,
    ProductImageReport,
    BergenEdi,
    StitchFixEdi,
    StyleLedger,
    TotalOts,
    PtToBergen,
    ChartofAccountReport,
    OmsStyleReportNew,
    OmsWashReportNew,
    StyleShot,
    StyleDistro,
    VendorSummary,
    Expense,
    RAToBergen,
    ARInventory,
    RAToBergen2,
    InventoryValuation,
    JournalLedger,
    GeneralLedger,
    OmsStockSummaryAts,
    PickTicketDetail,
    StockStyleWise,
    CustomerPaymentLedgerNew,
    BalanceSheetNew,
    APAgingDetail,
    IncomeStatementNew,
    JournalLedgerNew,
    AvalaraInvoice,
    SalesTargetRetportDashboard,
    CheckPay,
    CrmSkuWise,
    CRMReport,
    TransactionLock,
    SalesTargetReportSalePerson,
    ChargeBackDetail,
    ForgetPassword,
    UpcToItemCode,
    NetShippedStyleWise,
    CustomerHold,
    MissingUpc,
    CustomerPaymentLedgerDateWise,
    PendingOrderAvailabilityBySize,
    NegativeOrderOtsWise,
    NegativeOrderOtsWise2,
    Brand,
    SkuExistsErp,
    OnlineOrdersSummary,
    SpecialityByRegion,
    SpecialityByState,
    SpecialityByCustomer,
    EcommerceByStyle,
    DLBulk,
    WWBulk,
    ProductMigration,
    SpecialtyByStyle,
    RoutineLog,
    ImageUploaderNu,
    ScheelsEdi,
    Profile,
    LeaderBoard,
    CustomerRefundReportNew,
    ControlSheet2,
    InvoiceEmailTest,
    ProductionFinished,
    OMSStockStyleWiseSummary,
    ProductImageUrl,
    CustomerbyPO,
    DropshipSKU,
    DropshipTotal,
    SpecialityByMonth,
    CalenderForm,
    EventCalendar,
    AvalaraReturn,
    CCOrderProcessing,
    InvoicePendingPdf,
    CreditNoteEmail,
    CreditNoteEmailPdf,
    ProductImageReportNew,
    BusinessDashboardNew,
    AllocationReport,
    StyleWiseDetail,
    Collaterals,
    ItemCodeToUpc,
    NetShippedInventory,
    FabricWiseInventory,
    StyleWiseInventory,
    SizeCurveReport,
    SpecialtyByBookingReport,
    UserRightsMultiple,
    Dashboard,
    DLBill,
    ProductionSKUWisePercentage,
    ShippedStyleWisePercentage2,
    paymentReceiptReportNew,
    AdminDepartment,
    JournalVoucherReport,
    UserRegion,
    ArCustomerPaymentLedger,
    PaymentAdjustment,
    ControlSheetAdvanceShip,
    CustomerCreditReport,
    CustomerAdjustmentReport,
    ReturnAuthorizationReport,
    CustomerPaymentPrint,
    ControlSheetAdvanceShipLog,
    CustomerRefundPrint,
    PendingStyleWiseWithAvailability
}